import instance, { customConfig } from "../../../Utils/Interceptors/Interceptor";

const ObtenerMacroubicaciones = async (values) => {
    try {
        const resultado = await instance.Backend.post("/InformeConservacion/ObtenerMacroubicaciones",values, customConfig);

        return resultado

    } catch (error) {

        console.log(error);

    }

}
export { ObtenerMacroubicaciones };
